import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const SEVERITY_STYLES = {
  broken: {
    border: "border-red-200",
    bg: "bg-red-50",
    badge: "bg-red-100 text-red-700",
    dot: "bg-red-400",
    title: "text-red-950",
    detail: "text-red-800",
    evidence: "text-red-700",
    toggle: "text-red-500 hover:text-red-700",
  },
  notice: {
    border: "border-amber-200",
    bg: "bg-amber-50",
    badge: "bg-amber-100 text-amber-700",
    dot: "bg-amber-400",
    title: "text-amber-950",
    detail: "text-amber-800",
    evidence: "text-amber-700",
    toggle: "text-amber-500 hover:text-amber-700",
  },
};

const PHASE_LABELS = {
  homepage: "Homepage",
  product_page: "Product page",
  add_to_cart: "Add to cart",
  checkout_handoff: "Checkout",
};

export default function FindingCard({ finding }) {
  const [expanded, setExpanded] = useState(false);
  const s = SEVERITY_STYLES[finding.severity] ?? SEVERITY_STYLES.notice;
  const hasEvidence = finding.evidence?.length > 0;

  return (
    <div className={["rounded-lg border p-4", s.border, s.bg].join(" ")}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className={["rounded-full px-2 py-0.5 text-xs font-semibold", s.badge].join(" ")}>
              {finding.severity === "broken" ? "Broken" : "Notice"}
            </span>
            {finding.phase && (
              <span className="rounded-full bg-white/70 px-2 py-0.5 text-xs text-gray-500 ring-1 ring-gray-200">
                {PHASE_LABELS[finding.phase] ?? finding.phase}
              </span>
            )}
          </div>
          <p className={["mt-2 text-sm font-semibold", s.title].join(" ")}>
            {finding.title}
          </p>
          <p className={["mt-1 text-sm", s.detail].join(" ")}>
            {finding.detail}
          </p>
        </div>
      </div>

      {hasEvidence && (
        <div className="mt-3">
          <button
            type="button"
            onClick={() => setExpanded((e) => !e)}
            className={["flex items-center gap-1 text-xs font-medium", s.toggle].join(" ")}
          >
            {expanded
              ? <ChevronDown className="h-3.5 w-3.5" />
              : <ChevronRight className="h-3.5 w-3.5" />}
            {expanded ? "Hide details" : `Show details (${finding.evidence.length})`}
          </button>
          {expanded && (
            <ul className="mt-2 space-y-1">
              {finding.evidence.map((item, i) => (
                <li key={i} className={["flex items-start gap-2 text-xs font-mono", s.evidence].join(" ")}>
                  <span className={["mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full", s.dot].join(" ")} />
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
